import React, { ReactElement, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { login, selectUser } from '../slice/userSlice';
import { SendLoginEvent } from '../utils/gtag';
import { Loading } from './common/loading';

export const Auth: React.FC<{ children: ReactElement }> = (props) => {
    const dispatch = useDispatch();
    const { isAuth } = useSelector(selectUser);

    const history = useHistory();
    useEffect(() => {
        dispatch(login());
        SendLoginEvent('cocalero');
    }, [dispatch]);

    if (isAuth === undefined) {
        return <Loading />;
    }
    if (!isAuth) {
        history.push('/signin');
        return <></>;
    }
    return props.children;
};
